import DocumentFolderOpenLine from './document-folder-open-line.component.js'

export * from './document-folder-open-line.component.js'
export default DocumentFolderOpenLine

DocumentFolderOpenLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-folder-open-line': DocumentFolderOpenLine
  }
}
